<template>
  <div class="header">
    <i class="m-icon mi-back" @click="goback()"></i>
    <i v-if="showhome" class="m-icon mi-home" @click="$router.push('/')"></i>
    <span class="title">{{title}}</span>
    <img v-if="showlogo&&logoIndex==1" src="../../../static/estate_mtxlogo.png" class="logo_mtx">
    <img v-if="showlogo&&logoIndex==2" src="../../../static/estate_mllogo.png" class="logo_ml">
    <img v-if="showlogo&&logoIndex==3" src="../../../static/estate_zmflogo.png" class="logo_zmf">
    <img v-if="showlogo&&logoIndex==4" src="../../../static/estate_mdrlogo.png" class="logo_mdr">
  </div>
</template>

<script>
export default {
  name: 'WapHeader',
  props:{
    title:String,
    showhome:Boolean,
    showlogo:Boolean,
  },
  data(){
    return {
      logoIndex: this.$store.state.domainIndex,
    }
  },
  mounted(){
  },
  methods:{
    goback(){
      console.log()
      if (window.history.length <= 1) {
        this.$router.push({path:'/'})
        return false
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style scoped>
.header{background:#fff;height:32px;box-shadow:0 0 3px #ddd;position:fixed;z-index:8;left:0;right:0;top:0;padding:0 15px;line-height:20px;padding-top:14px;text-align:center;}
.mi-back{width:11px;height:19px;background-position:-150px -79px;float:left;}
.mi-home{width:19px;height:19px;background-position:-162px -79px;float:right;}
.title{font-size:17px;color:#000;}
.logo_mtx,.logo_ml,.logo_zmf,.logo_mdr{height:37px;position:absolute;left:50%;top:5px;z-index:11;}
.logo_mtx{width:96px;margin-left:-48px;height:30px;top:8px;}
.logo_ml{width:90px;margin-left:-44px;}
.logo_zmf{width:114px;margin-left:-57px;}
.logo_mdr{width:98px;margin-left:-49px;}
</style>



// WEBPACK FOOTER //
// src/components/public/WapHeader.vue